// Global constants for the whole app
import { ANALYTICS_ANONYMOUS_USER } from "@hex/common";
import {
  LDClient,
  LDContext,
  LDMultiKindContext,
  initialize,
} from "launchdarkly-js-client-sdk";

import { ORG_ID } from "./orgs.js";
import {
  launchDarklyClientId,
  launchDarklyContextJson,
  launchDarklyDisabled,
  launchDarklyFlagStateJson,
} from "./util/data.js";

declare global {
  interface Window {
    launchDarklyContext?: LDContext;
    // LDFlagsState is only exported on node sdk
    launchDarklyFlagState?: object;
  }
}

/* eslint-disable tree-shaking/no-side-effects-in-initialization -- SSR JSON bootstrap → `window` for LD + HexRoutes */
if (launchDarklyFlagStateJson != null && launchDarklyFlagStateJson !== "") {
  try {
    window.launchDarklyFlagState = JSON.parse(
      launchDarklyFlagStateJson,
    ) as object;
  } catch (_error) {
    console.error(
      "Failed to parse LaunchDarkly flag bootstrap from document head",
    );
  }
}
if (launchDarklyContextJson != null && launchDarklyContextJson !== "") {
  try {
    window.launchDarklyContext = JSON.parse(
      launchDarklyContextJson,
    ) as LDContext;
  } catch (_error) {
    console.error(
      "Failed to parse LaunchDarkly context bootstrap from document head",
    );
  }
}
/* eslint-enable tree-shaking/no-side-effects-in-initialization */

const DEFAULT_CONTEXT: LDMultiKindContext = {
  kind: "multi",
  user: {
    key: ANALYTICS_ANONYMOUS_USER.id,
    name: ANALYTICS_ANONYMOUS_USER.name,
    email: ANALYTICS_ANONYMOUS_USER.email,
    anonymous: true,
  },
  organization: {
    key: ORG_ID,
  },
};

const LD_CONTEXT = window.launchDarklyContext ?? DEFAULT_CONTEXT;
let LD_CLIENT: LDClient | undefined;

export function getLdClient(): LDClient | undefined {
  if (LD_CLIENT == null && !launchDarklyDisabled && launchDarklyClientId) {
    LD_CLIENT = initialize(launchDarklyClientId, LD_CONTEXT, {
      // we disable client side events since we were rely on our own `Feature Flag
      // Evaluated` event instead.
      sendEventsOnlyForVariation: false,
      bootstrap: window.launchDarklyFlagState,
    });

    if (window.launchDarklyFlagState == null) {
      window.launchDarklyFlagState = LD_CLIENT.allFlags();
    }
    if (window.launchDarklyContext == null) {
      window.launchDarklyContext = LD_CONTEXT;
    }
  }
  return LD_CLIENT;
}
